.b3{min-width:0px;}